import {
    INIT_APP, INIT_APP_RESPONSE, VARIFY_OTP, VARIFY_OTP_RESPONSE, PMS_CODE_RESPONSE,
    MENU_ROLE_WISE_RESPONSE, MASTER_MENU_RESPONSE
} from '../types/initApp'; 
import { masterMenuOptions } from '../../helper/constant';

//SA Changes made for handling Popup --Abhishek
const initialState = {
    initDetails: "",
    pmsScheme: "",
    menuRoleWise: {},
    masterMenu: masterMenuOptions,
    // popupmenu: {} //Code commented for DXTech issue
}
//EA Changes made for handling Popup --Abhishek

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case INIT_APP_RESPONSE:
            return { ...state, initDetails: action.payload }
        case VARIFY_OTP:
            return { ...state, ...action.payload }
        case VARIFY_OTP_RESPONSE:
            return { ...state, initDetails: action.payload }
        case PMS_CODE_RESPONSE:
            return { ...state, pmsScheme: action.payload }
        case MENU_ROLE_WISE_RESPONSE:
            return { ...state, menuRoleWise: action.payload }
        case MASTER_MENU_RESPONSE:
            return { ...state, masterMenu: action.payload }
        // case POPUP_MENU_RESPONSE: //Changes made for handling Popup --Abhishek
        //     return { ...state, popupmenu: action.payload } //Code commented for DXTech issue
        default:
            return state
    }

}
